import { Card, CardBody, Col } from "reactstrap";
import { H6 } from "../../../AbstractElements";
import { AvatarInitialTitle } from "../../../Constants/Constants";
import { AvatarInitialData, AvatarInitialSubTitle } from "../../../Data/UiKits/Avatars";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const AvatarInitial = () => {
  return (
    <Col xl="4" sm="12">
      <Card>
        <CommonCardHeader title={AvatarInitialTitle} span={AvatarInitialSubTitle} />
        <CardBody className="common-align flex-column align-items-start align-items-lg-center">
          <div className="letter-avatar">
            {AvatarInitialData &&
              AvatarInitialData.map((item, index) => (
                <H6 key={index} className={`txt-${item.color} bg-light-${item.color}`}>
                  {item.text}
                </H6>
              ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default AvatarInitial;
